// MUST be imported first to suppress ResizeObserver errors before React starts
import "./errorSuppression"

import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import "./resizeObserverFix.css"
import App from "./App"
import ResizeObserverErrorBoundary from "./ResizeObserverErrorBoundary"
import * as serviceWorker from "./serviceWorker"

ReactDOM.render(
	<ResizeObserverErrorBoundary>
		<App />
	</ResizeObserverErrorBoundary>,
	document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
